<template>
    <div class="share-wrapper" v-if="nativeShare">
        <div v-if="nativeShare" class="native-share-buttons">
            <button class="native-share-button" @click.stop.prevent="share">
                <svg
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    width="100%"
                    height="100%"
                >
                    <path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8" />
                    <polyline points="16 6 12 2 8 6" />
                    <line x1="12" y1="2" x2="12" y2="15" />
                </svg>
                Share
            </button>
            <button class="native-share-button" @click.stop.prevent="print">
                <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M19 8H5c-1.66 0-3 1.34-3 3v6h4v4h12v-4h4v-6c0-1.66-1.34-3-3-3zm-3 11H8v-5h8v5zm3-7c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm-1-9H6v4h12V3z"
                        fill="#272727"
                    />
                    <path d="M0 0h24v24H0z" fill="none" />
                </svg>
                Print
            </button>
        </div>
        <div v-if="!nativeShare" class="addthis_inline_share_toolbox"></div>
    </div>
</template>

<script>
export default {
    props: ['title'],
    data() {
        return {
            nativeShare: typeof navigator.share !== 'undefined',
        };
    },
    created() {
        if (!this.shouldInitializeAddThis) {
            return;
        }

        setTimeout(() => {
            window['addthis_share'].url = window.location.href;
            window['addthis_share'].title = window.document.title;

            window.addthis.toolbox('.addthis_inline_share_toolbox');
            window.addthis.layers.refresh();
        }, 100);
    },
    computed: {
        shouldInitializeAddThis() {
            return false;

            return (
                !this.nativeShare &&
                typeof window.addthis !== 'undefined' &&
                typeof window['addthis_share'] !== 'undefined'
            );
        },
    },
    methods: {
        share() {
            navigator
                .share({
                    title: window.document.title,
                    url: window.location.href,
                })
                .catch(() => {
                    // Do nothing, they probably just aborted sharing
                });
        },
        print() {
            window.print();
        },
    },
};
</script>
